import React from 'react';

interface RiskItemProps {
  label: string;
  value: number;
  status: 'low' | 'medium' | 'high';
  description?: string;
}

const RiskItem: React.FC<RiskItemProps> = ({
  label,
  value,
  status,
  description
}) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'low': return '#28A049';
      case 'medium': return '#007BC2';
      case 'high': return '#F37D42';
      default: return '#28A049';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'low': return 'Nguy Cơ Thấp';
      case 'medium': return 'Nguy Cơ Trung Bình';
      case 'high': return 'Nguy Cơ Cao';
      default: return 'Nguy Cơ Thấp';
    }
  };

  const getStatusIcon = (status: string) => {
    // All risk items use the "good" checkmark icon from Figma
    return (
      <svg width="18.33" height="18.33" viewBox="0 0 18.33 18.33" fill="none">
        <g transform="translate(0.83, 0.83)">
          <path d="M4.17 5.69L9.43 12.76" stroke={getStatusColor(status)} strokeWidth="2" fill="none"/>
          <circle cx="8.165" cy="8.165" r="8.165" stroke={getStatusColor(status)} strokeWidth="2" fill="none"/>
        </g>
      </svg>
    );
  };

  return (
    <div style={{
      width: '115px',
      height: '80px',
      backgroundColor: '#FFFFFF',
      border: `0.5px solid ${getStatusColor(status)}`,
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '-10px',
      padding: '0px 0px 8px 0px'
    }}>
      {/* Header with icon and percentage */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        width: '100%'
      }}>
        <div style={{
          width: '20px',
          height: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {getStatusIcon(status)}
        </div>
        <div style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 800,
          fontSize: '12px',
          lineHeight: '2.461em', /* 29.54px / 12px = 2.461em */
          color: getStatusColor(status),
          width: '40px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {value}%
        </div>
      </div>

      {/* Content */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '-7px',
        width: '100%',
        alignItems: 'center'
      }}>
        <div style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 800,
          fontSize: '8px',
          lineHeight: '3.692em', /* 29.54px / 8px = 3.692em */
          textAlign: 'center',
          color: getStatusColor(status),
          width: '100%',
          height: '17px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {label}
        </div>
        <div style={{
          fontFamily: 'BT Beau Sans, Inter, sans-serif',
          fontWeight: 300,
          fontSize: '9px',
          lineHeight: '3.282em', /* 29.54px / 9px = 3.282em */
          textAlign: 'center',
          color: getStatusColor(status),
          width: '100%',
          height: '17px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {description || getStatusText(status)}
        </div>
      </div>
    </div>
  );
};

export default RiskItem;
